import React from 'react';
import { useLanguage } from '../../i18n/LanguageContext';
import './style.css';

const languages = [
  { code: 'ja', shortLabel: '日', translationKey: 'language.japanese' },
  { code: 'zh', shortLabel: '中', translationKey: 'language.chinese' },
  { code: 'en', shortLabel: 'EN', translationKey: 'language.english' },
];

const LanguageSwitcher = () => {
  const { language, setLanguage, t } = useLanguage();

  return (
    <div className="language-switcher" role="group" aria-label={t('language.label')}>
      {languages.map(({ code, shortLabel, translationKey }) => (
        <button
          key={code}
          type="button"
          className={language === code ? 'active' : ''}
          onClick={() => setLanguage(code)}
          aria-pressed={language === code}
          title={t(translationKey)}
        >
          {shortLabel}
        </button>
      ))}
    </div>
  );
};

export default LanguageSwitcher;
